module.exports = __webpack_public_path__ + "img/lv2.681ce39b.png";